import { render, staticRenderFns } from "./choose-city.vue?vue&type=template&id=4fe2a8e5&"
import script from "./choose-city.vue?vue&type=script&lang=js&"
export * from "./choose-city.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports